import { Title, Texts, Media } from "../Object";
import { Space } from "../Layout";
import { Scroll } from "../Animation";

const Problem = () => {
  return(
    <>
      <div className="l-row">
        <Title slug="problem" />
        <List />
      </div>
    </>
  )
}

export const List = (props) => {
  const args = {
    slug: props.slug ?? 'problem',
    length: props.length ?? 3,
  }
  const Item = (props) => {
    return(
      <>
        <li className="c-grid__items--border" data-state={`repeat-${args.length}`}>
          <Media src={`${args.slug}/list${props.index}`} alt="media" class="p-img__problem" />
          <Scroll>
            <Space size={['40px 0', '32px 0']}>
              <Texts slug={`${args.slug}/list-title-${props.index}`} class="c-text--center c-text--bold" />
            </Space>
          </Scroll>
          <Scroll>
            <Texts slug={`${args.slug}/list-body-${props.index}`} class="c-text--med" />
          </Scroll>
        </li>
      </>
    )
  }
  let items = [];
  for (let i = 0; i < args.length; i++) {
    items.push(<Item key={i} index={i} />);
  }

  return (
    <>
      <ul className={`c-grid__wrap--repeat-${args.length}`}>
        { items }
      </ul>
    </>
  )
}

export default Problem;